(function(window, document) {
  'use strict';

  mint.on('documentLoaded', function() {
    document.querySelectorAll('.tabs--interactive').forEach(function(element) {
      let activeTabInstance = null;

      element.querySelectorAll('.tabs__toggle').forEach(function(toggle) {
        const content = element.querySelector('#' + toggle.getAttribute('aria-controls'));
        const tabInstance = mint.components.switchButton(toggle, {
          durationCssVariable: '--tabs-transition-duration',
          closeOnEscape: false,
          closeOnFocusOut: false
        });

        if(toggle.classList.contains('is--active') === true) {
          activeTabInstance = tabInstance;
        }

        toggle.addEventListener('switch-button.activate', function() {
          if(activeTabInstance !== null) {
            activeTabInstance.deactivate();
          }

          setTimeout(function() {
            activeTabInstance = tabInstance;
          }, 0);
        });
      });
    });
  });
})(window, document);
